import React, { useEffect, useRef } from 'react';
import { AuthProvider as OidcAuthProvider, useAuth } from 'react-oidc-context';
import { userManager } from './userManager';
import { refreshAccessToken } from './refreshAccessToken';
import { setAccessToken, setRefreshCallback, setSessionExpiredCallback } from '../shared/lib/apiClient';
import { SESSION_FLASH_KEY } from '../shared/lib/sessionFlash';

function TokenSync(): null {
  const auth = useAuth();
  const authRef = useRef(auth);
  authRef.current = auth;

  useEffect(() => {
    setAccessToken(auth.user?.access_token ?? null, auth.user?.expires_at);
  }, [auth.user?.access_token, auth.user?.expires_at]);

  useEffect(() => {
    setRefreshCallback((staleToken) => refreshAccessToken(userManager, staleToken));

    setSessionExpiredCallback(() => {
      sessionStorage.setItem(SESSION_FLASH_KEY, 'Sua sessão expirou. Faça login novamente.');
      void authRef.current.removeUser?.();
    });

    return () => {
      setRefreshCallback(null);
      setSessionExpiredCallback(null);
    };
  }, []);

  return null;
}

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <OidcAuthProvider userManager={userManager}>
    <TokenSync />
    {children}
  </OidcAuthProvider>
);

// eslint-disable-next-line react-refresh/only-export-components
export { useAuth };
